import type {
  RecruitingCities_City as RecruitingCity,
  LearnerProfile_UserLocation as UserLocation,
} from '__generated__/graphql-types-do-not-use';

import type { LearnerProfile_IssuedBadgeFragment as Badge } from 'bundles/account-profile/components/recruiting-profile-viewer/queries/__generated__/LearnerProfileBadgeFragment';

export const getLocationLabel = ({ cityName, stateName, countryName }: UserLocation) => {
  if (!cityName && !countryName && !stateName) return '';
  return [cityName, stateName, countryName].filter(Boolean).join(', ');
};

export const getLocationItem = (city: RecruitingCity, label: string) => {
  return {
    id: `${city.lat}:${city.lng}`,
    label,
    value: {
      latitude: city.lat,
      longitude: city.lng,
      label,
    },
  };
};

export const validateFullName = (name: string) => {
  const specialChars = /[!@#$%^&*()_+=[\]{};:"\\|,<>/?]+/;
  const numbers = /[0-9]/;
  const onlyUppercaseLetters = /^[A-Z| ]+$/;
  if (specialChars.test(name) || numbers.test(name) || onlyUppercaseLetters.test(name)) {
    return false;
  }
  return true;
};

export const isCourseraIssuedBadge = (badge: Badge) => badge.issuedBadgeSource === 'COURSERA';

export const onlyCourseraIssuedBadges = (issuedBadges: Badge[]) => issuedBadges.filter(isCourseraIssuedBadge);
